<div class="architech1" *ngIf="!photoViewMode">
  <div class="architech-photo" *ngIf="photoNameMode !== 'Name'">
    <!-- <img [ngClass]="photoNameMode=='Image'?'arch-img1':'arch-img'"  *ngIf="userObj?.photoURL" [src]="userObj?.photoURL"> -->
    <div *ngIf="showtooltip" placement="bottom" delay="300">
      <img
        class="arch-img1"
        *ngIf="userObj?.photoURL"
        [src]="userObj?.photoURL"
      />
    </div>
    <div *ngIf="showtooltip" placement="bottom" delay="300">
      <img
        class="arch-img1"
        *ngIf="!userObj?.photoURL"
        src="./../../../assets/avatar.png"
      />
    </div>
    <!-- ........................without tooltip................................. -->
    <img
    class="arch-img1"
   
    *ngIf="userObj?.photoURL && !showtooltip"
    [src]="userObj?.photoURL"
  />
  <img
      class="arch-img1"

    *ngIf="!userObj?.photoURL && !showtooltip"
    src="./../../../assets/avatar.png"

  />
    <!-- .................................................................... -->
  </div>

  <div class="architech-name" *ngIf="photoNameMode !== 'Image'">
    <div placement="bottom" delay="300">
      <span class="arch-name">{{ userObj?.displayName }}</span>
    </div>
  </div>
</div>

<div *ngIf="photoViewMode">
  <div class="singleimagecontainer">
    <img
      *ngIf="userObj?.photoURL"
      [src]="userObj?.photoURL"
      alt="user"
      class="teamimage"
    />
    <img
      *ngIf="!userObj?.photoURL"
      src="./../../../assets/avatar.png"
      alt="user"
      class="teamimage"
    />
    <div class="overlay">
      <h4 class="user-name">{{ userObj?.displayName }}</h4>
      <p class="user-role">{{ userObj?.role }}</p>
    </div>
  </div>
</div>
